import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, whatsappLink } from "../../lib/site";
import { Reveal } from "../site/Reveal";

const ServiceCard = ({ service, index }) => {
  const Icon = service.icon;
  return (
    <motion.a
      href={whatsappLink(`Hi Bezalel Property Services, I'd like a quote for ${service.name} ${service.sub}.`)}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group relative flex flex-col overflow-hidden rounded-xl border border-white/10 bg-forest-surface hover:border-brand-orange/60 transition-colors duration-400"
      data-testid={`service-card-${index}`}
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={service.image}
          alt={`${service.name} ${service.sub}`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-surface via-forest-surface/20 to-transparent" />
        <div className="absolute top-3 left-3 grid place-items-center h-12 w-12 rounded-full bg-forest/70 backdrop-blur border border-white/15 text-brand-orange">
          <Icon className="h-6 w-6" strokeWidth={1.8} />
        </div>
      </div>
      <div className="flex items-center justify-between p-5">
        <div>
          <h3 className="font-display uppercase tracking-tight text-2xl text-cream leading-none">{service.name}</h3>
          <p className="mt-1 text-cream/55 text-sm font-body">{service.sub}</p>
        </div>
        <span className="grid place-items-center h-10 w-10 rounded-full border border-white/15 text-cream/70 group-hover:bg-brand-orange group-hover:text-white group-hover:border-brand-orange transition-[background-color,color,border-color] duration-300">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </motion.a>
  );
};

export const Services = () => (
  <section id="services" className="relative bg-forest py-24 md:py-32 scroll-mt-20" data-testid="services-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div className="max-w-2xl">
          <span className="font-display uppercase tracking-[0.25em] text-xs text-brand-orange">Our Services</span>
          <h2 className="mt-4 font-display uppercase tracking-tight text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95]">
            Twelve trades,<br /><span className="text-brand-orange">one team</span>
          </h2>
        </div>
        <p className="text-cream/70 max-w-sm leading-relaxed">
          Tap any service to start a WhatsApp enquiry. Whatever your property needs,
          we have the certified hands to deliver it.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.name} service={s} index={i} />
        ))}
      </div>
    </div>
  </section>
);
